// extracted by mini-css-extract-plugin
export default {"enter":"AppRouter_enter__462hk","enterActive":"AppRouter_enterActive__GWsY0","exit":"AppRouter_exit__n+wsY","exitActive":"AppRouter_exitActive__Bkaql"};